import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index.js'

// avoid NavigationDuplicated
['push', 'replace'].forEach(method => {
    const originalMethod = VueRouter.prototype[method];
    VueRouter.prototype[method] = function m(location) {
        return originalMethod.call(this, location).catch(error => {
            if (error.name !== 'NavigationDuplicated') {
                throw error
            }
        })
    };
});

Vue.use(VueRouter)

const checkAuth = async (to, from, next) => {
    await store.dispatch('auth/SET_AUTH_DATA')
    if (store.getters['auth/AUTH']) {
        await store.dispatch('auth/GET_USER_ROLE');
        return next()
    } else {
        return next('/authorization')
    }
}

const checkAccess = async (to, from, next, access) => {
    // await store.dispatch('auth/GET_USER_ROLE')

    if (store.getters['auth/ROLE']?.operations?.[access]?.access) {
        return next()
    } else {
        return next('/access-denied')
    }
}

// import {tours} from '@/data/trials';
import NotFound from "@/views/pages/Not-found.vue";

// const startTrial = (to, from) => {
//     let tour = tours[to.path]
//     if (tour) {
//         let exists = store.getters['dataEntities/NEW_TOURS'].some((el) => el._id === tour._id);
//         if (!exists) {
//             return false;
//         }
//         console.log('trial Started', from, to)
//
//         let permittedSteps = tour.steps.filter((step) => {
//             if(step.permission?.length){
//                 if(store.getters['auth/ROLE'].operations[to.path.substring(1)]?.[step.permission]){
//                     return true
//                 }
//             } else {
//                 return true
//             }
//         })
//
//         store.commit('tour/INIT_TOUR', {
//             options: tour.options,
//             steps: permittedSteps
//         })
//
//         store.commit('tour/START_TOUR')
//     }
//     return true
// }

// const checkRole = async (to, from, next) => {
//   await store.dispatch('auth/CHECK_AUTH')

//   if (to.path !== '/profile' && to.path !== '/my_tests') {
//     if (store.getters['auth/OPERATIONS'].access[to.path.substring(1)] ) {
//       return next();
//     } else {
//       return next('/access-denied');
//     }
//   }
// }

const routes = [
    {
        path: '*',
        redirect: '/my-tests'
    },
    {
        path: '/authorization',
        component: () => import('@/views/pages/authorization/m-authorization.vue'),
        meta: { title: 'Мератест' },
        children: [
            {
                path: '',
                component: () => import('@/components/auth/m-authorization-form.vue'),
                beforeEnter: (to, from, next) => {
                    if (to.query.code && to.query.service) {
                        next({
                            path: '/authorization/login-with',
                            query: { code: to.query.code, service: to.query.service }
                        });
                    } else {
                        next();
                    }
                }
            },
            {
                path: 'recovery',
                name: 'recovery',
                props: true,
                component: () => import('@/views/pages/authorization/m-password-recover.vue'),
            },
            {
                path: 'login-with',
                name: 'LoginWith',
                component: () => import('@/components/auth/m-authorization-cid-input.vue')
            }
        ]
    },
    {
        path: '/authorization/code-input/:cid/:id',
        component: () => import('@/views/pages/authorization/m-recovery-code-input.vue'),
        meta: {
            title: 'Мератест'
        },
    },
    {
        path: '/test-invite/:cid/:id',
        component: () => import('@/components/my-tests/m-my-tests-link.vue'),
        meta: {
            title: 'Мератест',
        },
    },
    {
        path: '/',
        component: () => import('@/views/layout/m-layout.vue'),
        beforeEnter: (to, from, next) => checkAuth(to, from, next),
        meta: {
            title: 'Главная'
        },
        children: [
            {
                path: '/access-denied',
                component: () => import('@/views/pages/Access-denied.vue'),
                meta: {
                    title: 'Доступ запрещен'
                },
            },
            {
                path: '/quiz-invite/:companyId/:linkCode',
                name: 'quiz-invite',
                component: () => import('@/views/pages/quizzes/m-quiz-invite-page.vue'),
                meta: {
                    title: 'Мератест'
                },
            },
            {
                path: `/quiz/:id/play`,
                name: 'quiz-play',
                component: () => import('@/components/quizzes/m-quiz-play.vue'),
                meta: {
                    title: 'Мератест'
                },
            },
            {
                path: `/quiz/:id/results`,
                name: 'quiz-play',
                component: () => import('@/components/quizzes/m-quiz-results.vue'),
                meta: {
                    title: 'Мератест'
                },
            },
            {
                path: '/profile',
                component: () => import('@/views/pages/profile/m-profile.vue'),
                meta: {
                    title: 'Профиль'
                },
            },
            {
                path: '/profile/plans',
                component: () => import('@/components/plans/m-plans.vue'),
                meta: {
                    title: 'Тарифы',
                    breadcrumbParent: '/profile'
                },
            },
            {
                path: '/company',
                component: () => import('@/views/pages/company/m-company.vue'),
                meta: {
                    title: 'Компания'
                },
                beforeEnter: (to, from, next) => checkAccess(to, from, next, 'company'),
            },
            {
                path: '/my-tests',
                component: () => import('@/views/pages/my-tests/m-my-tests.vue'),
                meta: {
                    title: 'Мои тесты'
                }
            },
            {
                path: '/preview-test/:id',
                name: 'my-tests-view',
                component: () => import('@/views/pages/test/m-test.vue'),
                meta: {
                    title: 'Предпросмотр шаблона',
                    breadcrumbParent: '/test-templates/edit/:id'
                    // title: 'Мератест'
                },
            },
            {
                path: '/my-tests/:id',
                component: () => import('@/views/pages/test/m-test.vue'),
                meta: {
                    title: 'Тестирование',
                    breadcrumbParent: '/my-tests'
                    // title: 'Мератест'
                },
            },
            {
                path: '/all-tests',
                component: () => import('@/views/pages/all-tests/m-all-tests.vue'),
                meta: {
                    title: 'Все тесты'
                },
                beforeEnter: (to, from, next) => checkAccess(to, from, next, 'all-tests'),
            },
            {
                path: '/all-tests/edit/:id',
                component: () => import('@/components/all-tests/all-tests-editing/m-all-tests-editing.vue'),
                meta: {
                    title: 'Редактирование теста',
                    breadcrumbParent: '/all-tests'
                },
                beforeEnter: (to, from, next) => checkAccess(to, from, next, 'all-tests'),
            },
            {
                path: '/all-tests/:id/results',
                component: () => import('@/views/pages/test-results/m-test-results'),
                meta: {
                    title: 'Результаты тестирования',
                    breadcrumbParent: '/all-tests'
                },
                beforeEnter: (to, from, next) => checkAccess(to, from, next, 'all-tests'),
            },
            {
                path: '/test-templates',
                component: () => import('@/views/pages/test-templates/m-test-templates.vue'),
                meta: {
                    title: 'Шаблоны тестов'
                },
                beforeEnter: (to, from, next) => checkAccess(to, from, next, 'test-templates'),
            },
            {
                path: '/test-templates/new',
                component: () => import('@/components/m-test-templates/m-test-templates-editing/m-test-templates-editing.vue'),
                meta: {
                    title: 'Создание',
                    breadcrumbParent: '/test-templates'
                },
                beforeEnter: (to, from, next) => checkAccess(to, from, next, 'test-templates'),
            },
            {
                path: '/test-templates/edit/:id',
                component: () => import('@/components/m-test-templates/m-test-templates-editing/m-test-templates-editing.vue'),
                meta: {
                    title: 'Редактирование',
                    breadcrumbParent: '/test-templates'
                },
                beforeEnter: (to, from, next) => checkAccess(to, from, next, 'test-templates'),
            },
            {
                path: '/quizzes',
                name: 'quizzes',
                component: () => import('@/views/pages/quizzes/m-quizzes.vue'),
                meta: {
                    title: 'Квизы',
                },
            },
            {
                path: '/quizzes/:id',
                component: () => import('@/components/quizzes/m-quiz-open.vue'),
                meta: {
                    title: 'Квиз',
                },
            },
            {
                path: '/NSI',
                component: () => import('@/components/nsi/m-nsi.vue'),
                meta: {
                    title: 'Нормативно справочная информация'
                },
                // beforeEnter: (to, from, next) => checkAccess(to, from, next, 'question-collections'),
            },
            {
                path: '/NSI/collections',
                name: 'nsi-collections',
                component: () => import('@/components/question-collections/m-question-collections.vue'),
                meta: {
                    title: 'Коллекции вопросов',
                    breadcrumbParent: '/NSI'
                }
            },
            {
                path: '/NSI/themes',
                name: 'nsi-test-themes',
                component: () => import('@/components/themes/m-test-themes.vue'),
                meta: {
                    title: 'Направления тестирования',
                    breadcrumbParent: '/NSI'
                }
            },
            {
                path: '/mailings',
                component: () => import('@/views/pages/mailing/m-mailings.vue'),
                meta: {
                    title: 'Рассылки'
                },
                beforeEnter: (to, from, next) => checkAccess(to, from, next, 'mailings'),
            },
            {
                path: '/mailings/create',
                component: () => import('@/components/mailings/m-mailing-editing/m-mailing-create.vue'),
                meta: {
                    title: 'Создание',
                    breadcrumbParent: '/mailings'
                },
                beforeEnter: (to, from, next) => checkAccess(to, from, next, 'mailings'),
            },
            {
                path: 'mailings/edit/:type/:id',
                component: () => import('@/components/mailings/m-mailing-editing/m-mailing-create.vue'),
                meta: {
                    title: 'Редактирование',
                    breadcrumbParent: '/mailings'
                },
                beforeEnter: (to, from, next) => checkAccess(to, from, next, 'mailings'),
            },
            {
                path: '/tariffs-edit',
                component: () => import('@/components/plans/admin/m-plans-edit.vue'),
                meta: {
                    title: 'Редактирование тарифов',
                },
                beforeEnter: (to, from, next) => {
                    const user = store.getters['auth/USER']

                    if (user?.company?.name === 'admin') {
                        next()
                    } else {
                        next({ path: '/' })
                    }
                }
            },
            {
                path: '/reports',
                component: () => import('@/views/pages/report/m-reports.vue'),
                meta: {
                    title: 'Отчеты'
                },
                beforeEnter: (to, from, next) => checkAccess(to, from, next, 'reports'),
            },
            {
                path: '/reports/:path',
                component: () => import('@/components/reports/report/m-report-layout.vue'),
                meta: {
                    title: 'Отчеты'
                },
                beforeEnter: (to, from, next) => checkAccess(to, from, next, 'reports'),
            },
            {
                path: '/articles',
                component: () => import('@/components/articles/m-articles.vue'),
                meta: {
                    title: 'Лекции и материалы'
                },
            },
            {
                path: '/info',
                component: () => import('@/components/info/m-info.vue'),
                meta: {
                    title: 'Справка'
                },
            },
            {
                path: '/info/:id',
                component: () => import('@/components/info/m-info.vue'),
            },
            {
                path: '/articles/external/:id',
                component: () => import('@/components/articles/m-articles.vue'),
                meta: {
                    title: 'Статья',
                    breadcrumbParent: '/articles'
                },
            },
            {
                path: '/articles/:id',
                component: () => import('@/components/articles/m-articles.vue'),
                meta: {
                    title: 'Статья',
                    breadcrumbParent: '/articles'
                },
            },
            {
                path: '/schedules',
                component: () => import('@/views/pages/schedules/m-schedules.vue'),
                meta: {
                    title: 'График'
                    // title: 'Мератест'
                },
                // beforeEnter: (to, from, next) => checkAccess(to, from, next, 'reports'),
            },
            {
                path: '/my-schedule',
                component: () => import('@/components/user-events/m-user-events.vue'),
                meta: {
                    title: 'Мое расписание',
                    breadcrumbParent: '/schedules'
                },
                // beforeEnter: (to, from, next) => checkAccess(to, from, next, 'reports'),
            },
            {
                path: '/stream',
                component: () => import('@/components/m-stream-main.vue'),
                meta: {
                    title: 'Stream',
                    // breadcrumbParent: '/stream'
                },
                // beforeEnter: (to, from, next) => checkAccess(to, from, next, 'reports'),
            },
            {
                path: '/:pathMatch(.*)*',
                name: 'NotFound',
                component: NotFound,
            },
        ],
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    if(to.path !== from.path){
        store.commit('tour/CANCEL_TOUR')
    }
    document.title = to.meta?.title ? `${to.meta.title} | Мератест` : 'Мератест'

    if (to.path === '/') {
        next('/my-tests')
    } else {
        next()
    }
})

router.afterEach((to) => {
    console.log('afterEach', to.fullPath)

    if (!to.meta.title) return

    store.dispatch('tabs/addTab', to)
    // startTrial(to, from)
})

export default router
